import React from 'react';
import { Space } from 'antd';
import type { SpaceProps } from 'antd';

export type AppSpaceProps = SpaceProps;

const AppSpace = React.forwardRef<HTMLDivElement, AppSpaceProps>((props, ref) => {
  return <Space ref={ref} {...props} />;
});

AppSpace.displayName = 'AppSpace';

export default AppSpace;
